class Credits {
  constructor() {
    this.initClickEvents();
  }

  initClickEvents() {
    let links: Array<HTMLLinkElement> = Array.from(document.querySelectorAll('.credits a'));

    links.forEach(link => {
      link.addEventListener('click', this.linkClickedHandler)
    })
  }

  linkClickedHandler(event: Event) {
    let link: HTMLLinkElement = event.target as HTMLLinkElement,
      image = document.querySelector('[src="' + link.href + '"],[href="' + link.href + '"]');

    if (image != null) {
      image.scrollIntoView(false);
      event.preventDefault();
    }
  }
}

export default Credits;
